import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getNashvilleStructuredData() {
  const url = "https://restorehair.com/locations/tennessee/nashville/";
  const description =
    "Find out about your hair transplant options in Nashville with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("nashville", url, description),
    locationPageCrumbs(url, "Nashville"),
  ];
}
